import { theme as antTheme, type ThemeConfig } from "antd";
import { getContrastColor } from "./helpers";

export function buildAntTheme(c: ICustomizationData): ThemeConfig {
    return {
        algorithm: antTheme.defaultAlgorithm, // Force light mode

        // ── Global tokens ──────────────────────────────────────────────────────
        token: {
            colorPrimary: c.colorPrimaryButtons,
            colorPrimaryActive: c.colorSelectedHeader,
            colorText: c.colorParagraphFont,
            colorLink: c.colorPrimaryButtons,
            colorInfo: c.colorPrimaryButtons,
        },

        // ── Component-level tokens ─────────────────────────────────────────────
        components: {
            Layout: {
                headerBg: c.colorHeaderFooter,
                headerColor: getContrastColor(c.colorHeaderFooter),
                footerBg: c.colorHeaderFooter,
                siderBg: c.colorNavigationBar,
            },
            Menu: {
                itemSelectedBg: c.colorSelectedHeader,
                itemSelectedColor: getContrastColor(c.colorSelectedHeader),
            },
            Button: {
                // Primary buttons already driven by colorPrimary token.
                // Map the secondary/default button variant explicitly:
                primaryColor: getContrastColor(c.colorPrimaryButtons, "#ffffff", "#000000"),
            },
            Badge: {
                colorPrimary: c.colorSecondaryButtons,
                colorTextLightSolid: getContrastColor(c.colorSecondaryButtons),
                colorBorderBg: getContrastColor(c.colorSecondaryButtons),
            },
            Input: {
                activeBg: c.colorForm,
                hoverBg: c.colorForm,
            },
            Select: {
                optionSelectedBg: c.colorForm,
            },
            DatePicker: {
                activeBg: c.colorForm,
            },
            Form: {
                labelColor: c.colorLabel,
                labelFontSize: 14,
            },
            Table: {
                rowSelectedBg: c.colorSelectedRow,
                rowSelectedHoverBg: c.colorSelectedRow,
                headerBg: c.colorHeaderFooter,
                headerColor: getContrastColor(c.colorHeaderFooter),
                headerSplitColor: getContrastColor(c.colorHeaderFooter, "#ffffff22", "#00000022"),
            },
            Typography: {
                titleMarginBottom: "0.5em",
                titleMarginTop: "0",
                // h1–h4 colour is set via CSS vars (Ant Design Typography
                // doesn't expose per-level colour tokens in v6)
            },
        },
    };
}
